import { define } from 'wicked-elements'
import { register, deregister } from 'tiny-pulsar'
import innout from '../lib/in-n-out'

define('[data-component~="subnav"]', {
  init () {
    this.id = this.element.dataset.source
    this.$sectionLinks = [...this.element.querySelectorAll(`[href]`)]
    this.$sections = [...document.querySelector(`[data-target=${this.id}]`).children]

    this.tracker = innout({
      elements: this.$sections.map((el, i) => ({
        element: el,
        index: i
      })),
      offset: () => window.innerHeight / 4,
      onEnter: e => this.render(e.id)
    })
  },
  connected () {
    setTimeout(() => {
      this.tracker.check()
    })
    register(`subnav:${this.id}`, () => {
      this.tracker.check()
    })
  },
  disconnected () {
    deregister(`subnav:${this.id}`)
  },
  updateHash (id) {
    if (history.pushState) {
      history.replaceState(null, null, id)
    } else {
      location.hash = id
    }
  },
  render (id) {
    this.$sectionLinks.forEach(el => {
      if (el.hash === `#${id}`) {
        el.parentNode.classList.add('active')
        this.updateHash(`#${id}`)
      } else {
        el.parentNode.classList.remove('active')
      }
    })
  }
})